import i18n from "@/i18n";
import _ from "@/boot/lodash";
import { HookCodes } from "@/data/enums/hooks";
import { createEventFunc, EventMapType, icon } from "./utils";
import { AdminRoutes } from "@/data/enums/router";

const createEventMap: EventMapType = (hookId, payload = {}) => ({
  [hookId]: {
    name: i18n.t(`_hook.${hookId}_name`).toString(),
    event: createEventFunc({
      ...payload,
      path: `_hook.${hookId}`,
      slots: event => [
        {
          slot: "reference",
          is: "u-link",
          message: _.get(event, "object.reference"),
          props: {
            tag: "router-link",
            to: {
              name: AdminRoutes.SUPPORT_TICKET,
              params: { ticketId: _.get(event, "object.id") }
            }
          }
        }
      ]
    })
  }
});

export default {
  ...createEventMap(HookCodes.UPDATE_TICKET_STATUS),
  ...createEventMap(HookCodes.TICKET_OPENED, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.TICKET_CLOSED, {
    icon: {
      name: "minus-circle",
      type: "is-grey"
    }
  }),
  ...createEventMap(HookCodes.CLIENT_OPENED_NEW_TICKET, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.USER_CLOSED_TICKET),
  ...createEventMap(HookCodes.UPDATE_TICKET),
  ...createEventMap(HookCodes.TICKET_WAITING_RESPONSE),
  ...createEventMap(HookCodes.TICKET_IN_PROGRESS),
  ...createEventMap(HookCodes.TICKET_CLIENT_REPLIED),
  ...createEventMap(HookCodes.CLIENT_CLOSED_TICKET),
  ...createEventMap(HookCodes.TICKET_REOPENED),
  ...createEventMap(HookCodes.CLIENT_TICKET_INACTIVE),
  ...createEventMap(HookCodes.USER_TICKET_INACTIVE),
  ...createEventMap(HookCodes.USER_DELETED_TICKET_MESSAGE, {
    icon: icon.danger
  }),
  ...createEventMap(HookCodes.USER_DELETED_PRIVATE_TICKET_MESSAGE, {
    icon: icon.danger
  }),
  ...createEventMap(HookCodes.USER_OPENED_NEW_TICKET, {
    icon: icon.success
  }),
  ...createEventMap(HookCodes.LEAD_OPENED_NEWT_TICKET, {
    icon: icon.success
  })
};
